/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Rag_Internal_Only_No_Sources_ResponseInputs */



/**
* | output |
* | --- |
* | "I cannot answer this from the linked knowledge sources. Please ask a question that can be answered from your organisation's documents, or have an admin link ..." |
*
* @param {Rag_Internal_Only_No_Sources_ResponseInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const rag_internal_only_no_sources_response = /** @type {((inputs?: Rag_Internal_Only_No_Sources_ResponseInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Rag_Internal_Only_No_Sources_ResponseInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Diese Frage kann ich nicht aus den verlinkten Wissensquellen beantworten. Bitte stellen Sie eine Frage, die aus den Dokumenten Ihrer Organisation beantwortet werden kann, oder lassen Sie weitere Quellen durch einen Administrator verknüpfen.")
	return /** @type {LocalizedString} */ ("I cannot answer this from the linked knowledge sources. Please ask a question that can be answered from your organisation's documents, or have an admin link more sources.")
});